export const COUNTRY_CODES = [
  { code: '+60', iso: 'MY', name: 'Malaysia' },
  { code: '+65', iso: 'SG', name: 'Singapore' },
  { code: '+673', iso: 'BN', name: 'Brunei' },
  { code: '+62', iso: 'ID', name: 'Indonesia' },
  { code: '+66', iso: 'TH', name: 'Thailand' },
  { code: '+63', iso: 'PH', name: 'Philippines' },
  { code: '+84', iso: 'VN', name: 'Vietnam' },
  { code: '+86', iso: 'CN', name: 'China' },
  { code: '+852', iso: 'HK', name: 'Hong Kong' },
  { code: '+886', iso: 'TW', name: 'Taiwan' },
  { code: '+91', iso: 'IN', name: 'India' },
  { code: '+61', iso: 'AU', name: 'Australia' },
  { code: '+44', iso: 'GB', name: 'United Kingdom' },
  { code: '+1', iso: 'US', name: 'United States' },
];

export const DEFAULT_COUNTRY_CODE = '+60';

// Sample account, pre-filled on the login screens while the portal runs on mock data.
export const DEMO_LOGIN = { countryCode: '+60', phone: '123456789', password: 'password123', code: '123456' };

/** Day periods used by the time picker. Bookable hours run 9:00 AM – 6:00 PM. */
export const DAY_PERIODS = [
  { key: 'morning', label: 'Morning', range: '9–12', from: '09:00', to: '12:00' },
  { key: 'afternoon', label: 'Afternoon', range: '12–3', from: '12:00', to: '15:00' },
  { key: 'evening', label: 'Evening', range: '3–6', from: '15:00', to: '18:00' },
];

export const SLOT_MINUTES = 30;
export const FEW_SLOTS_THRESHOLD = 3;

export const APPOINTMENT_STATUS = {
  pending: { label: 'Awaiting confirmation', short: 'Pending', tone: 'warning' },
  confirmed: { label: 'Confirmed', short: 'Confirmed', tone: 'success' },
  completed: { label: 'Completed', short: 'Completed', tone: 'neutral' },
  cancelled: { label: 'Cancelled', short: 'Cancelled', tone: 'danger' },
  no_show: { label: 'Missed', short: 'Missed', tone: 'neutral' },
};

export const UPCOMING_STATUSES = ['pending', 'confirmed'];
export const PAST_STATUSES = ['completed', 'no_show'];

export const CANCEL_REASONS = [
  'Schedule conflict',
  'Feeling better',
  'Booked by mistake',
  'Prefer another doctor',
  'Other',
];

export const GENDERS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
];

// Accent colours (see --accent-* tokens). accentFor(key) picks one consistently per name/id.
export const ACCENTS = ['sky', 'mint', 'violet', 'coral', 'pink', 'sun'];
export const accentFor = (key = '') => {
  let h = 0;
  for (let i = 0; i < key.length; i += 1) h = (h * 33 + key.charCodeAt(i)) >>> 0;
  return ACCENTS[h % ACCENTS.length];
};
